export default "__VITE_ASSET__D1GV8u8$__"